import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import './NoAccess.css';
import { GetImages } from '../../utils/GetImages';
import { PermissionContext } from '../../utils/context/PermissionContext';
import { URLS, generateMenuRoutes, generateMaintananceMenuRoutes, generateAccountMenuRoutes, generateCommunicationMenuRoutes } from '../../constants/constants';
import { UserLoginData } from '../../components/common/charts/Enums';
import { AccessLevelEnum } from '@propertelligent/client-api';

const NoAccess: React.FC = () => {
  const navigate = useNavigate();
  const context = useContext(PermissionContext);
  
  const handleClose = () => {
    // Attempt to go back
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }

    // Fallback: If no history, find the first available menu route
    const roleId = Number(sessionStorage.getItem("userRoleId")) || 1;
    const permissions = context?.permissions || {};

    const tryFindRoute = () => {
      // Mock values since we just need the structure for navigation paths
      const mockValues = { noOfProperties: 0, noOfUnits: 0, noOfTenants: 0, noOfServiceRequests: 0, noOfContractors: 0 };
      
      const allRoutes = [
        ...(generateMenuRoutes(mockValues, roleId) || []),
        ...(generateMaintananceMenuRoutes(mockValues, roleId) || []),
        ...(generateCommunicationMenuRoutes(mockValues, roleId) || []),
        ...(generateAccountMenuRoutes(mockValues, roleId) || [])
      ];

      // Find first route where user has at least ReadOnly access
      for (const route of allRoutes) {
         if (route?.permission) {
             const level = permissions[route.permission] ?? AccessLevelEnum.None;
             if (level >= AccessLevelEnum.ReadOnly) {
                 return route.path;
             }
         }
      }
      
      return URLS.LOGIN; // Absolute fallback if somehow they have NO permissions
    };

    const fallbackRoute = tryFindRoute();
    navigate(fallbackRoute);
  };

  return (
    <div id="noAccess" className="no-access-overlay">
      <div className="no-access-popup">
        <button className="close-button" onClick={handleClose}>
          <img src={GetImages.crossIcon} alt="Close" width={16} height={16} />
        </button>

        <div className="no-access-icon">
             <img src={GetImages.danger} alt="Close" width={40} height={40} />
        </div>

        <h2 className="no-access-title">Access Denied</h2>

        <p className="no-access-message">
          You don't have permission to access this page. Please contact your organization administrator if you believe this is an error.
        </p>
      </div>
    </div>
  );
};

export default NoAccess;
